'use client';

import React, { useEffect } from 'react';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { FROM_ONBOARDING_QUERY_PARAM } from '../../../global/urlUtils';

const OnboardingHandler: React.FC<{
  setMinimalHeader: (minimalHeader: boolean) => void;
}> = ({ setMinimalHeader }) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const isUserFromOnboarding = searchParams?.has(FROM_ONBOARDING_QUERY_PARAM);
    if (isUserFromOnboarding) {
      setMinimalHeader(true); // Show minimal header if user from onboarding

      if (searchParams) {
        const oldParams = new URLSearchParams(searchParams);
        oldParams.delete(FROM_ONBOARDING_QUERY_PARAM);
        void router.replace(`${pathname}?${oldParams.toString()}`); // remove fromOnboarding param from url
      }
    }
    //   Due to changes in NextJS 13, to be able to detect changes in the url, the searchParams hook must be used in combination with pathname.
    //   https://github.com/vercel/next.js/discussions/41934#discussioncomment-7755572
  }, [pathname, router, searchParams, setMinimalHeader]);

  return null;
};

export default OnboardingHandler;
